// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
var setText = $foreign.setTextImpl;
var setAttributes = function (node) {
    return function (attrs) {
        return function () {
            return $foreign["_setAttributes"](node, attrs);
        };
    };
};
var removeAttributes = $foreign.removeAttributesImpl;
var removeAllBetween = $foreign.removeAllBetweenImpl;
var parentNode = /* #__PURE__ */ (function () {
    return $foreign.parentNodeImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
})();
var moveAllBetweenInclusive = $foreign.moveAllBetweenInclusiveImpl;
var insertBefore = $foreign.insertBeforeImpl;
var createTextNode = $foreign.createTextNodeImpl;
var createElementNS = function (v) {
    if (v instanceof Data_Maybe.Just) {
        return $foreign.createElementNSImpl(v.value0);
    };
    if (v instanceof Data_Maybe.Nothing) {
        return $foreign.createElementImpl;
    };
    throw new Error("Failed pattern match at Specular.Dom.Browser (line 44, column 1 - line 44, column 61): " + [ v.constructor.name ]);
};
var createElement = /* #__PURE__ */ (function () {
    return createElementNS(Data_Maybe.Nothing.value);
})();
var createDocumentFragment = $foreign.createDocumentFragmentImpl;
var appendRawHtml = $foreign.appendRawHtmlImpl;
var appendChild = $foreign.appendChildImpl;
var addEventListener = $foreign.addEventListenerImpl;
export {
    removeNode,
    createTextNodeImpl,
    setTextImpl,
    createDocumentFragmentImpl,
    createElementNSImpl,
    createElementImpl,
    _setAttributes,
    removeAttributesImpl,
    parentNodeImpl,
    insertBeforeImpl,
    appendChildImpl,
    removeAllBetweenImpl,
    appendRawHtmlImpl,
    moveAllBetweenInclusiveImpl,
    addEventListenerImpl,
    preventDefault,
    innerHTML,
    getTextInputValue,
    setTextInputValue,
    getCheckboxChecked,
    setCheckboxChecked
} from "./foreign.js";
export {
    addEventListener,
    createTextNode,
    setText,
    createDocumentFragment,
    createElementNS,
    createElement,
    setAttributes,
    removeAttributes,
    parentNode,
    insertBefore,
    appendChild,
    appendRawHtml,
    removeAllBetween,
    moveAllBetweenInclusive
};
